import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { EndOfShift } from '@pos/app/scripts/services/end-of-shift';
import { Persist } from '@core/app/scripts/services/persist';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';

/*
 * Component responsible for /eos-submit-overview route.
 */
angular
  .module('posApp')
  .directive(
    'eosSubmitOverview',
    (
      displayMessage: DisplayMessage,
      endOfShift: EndOfShift,
      navigateTo: NavigateTo,
      persist: Persist,
      settingsManager: SettingsManager,
      translate: ng.translate.ITranslateService,
      eosSubmit,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./eos-submit-overview.html').default,

      link: function ($scope, element, attrs) {
        const $translate = translate,
          paymentMethods = settingsManager.settings.paymentMethods;

        $scope.eos = {};
        $scope.originalValues = {};
        $scope.totals = {};
        $scope.payments = {};
        $scope.cashDepositedInPOS = 0;
        $scope.totalsOpened = false;

        $scope.eosSubmit = eosSubmit;

        $scope.email = persist.get('eosEmail') ? persist.get('eosEmail') : '';

        let category, payment, i, j;

        $scope.eos = endOfShift.prepare(endOfShift.eos);
        $scope.originalValues = endOfShift.originalEOSValues;

        $scope.totals = endOfShift.totals;
        $scope.payments = endOfShift.payments;
        $scope.cashDepositedInPOS = endOfShift.cashDepositedInPOS;

        endOfShift.calculateTotals();

        for (i in $scope.originalValues.payments) {
          category = $scope.originalValues.payments[i];
          for (j in category) {
            payment = category[j];
            if (payment.value !== $scope.payments[i][j].value) {
              payment.changed = true;
            }
          }
        }

        $scope.getStyle = (original, update) => ({
          changedPayment: original !== update,
        });

        $scope.openMailPopup = () => {
          $scope.emailPopupOpened = true;
        };

        $scope.cancel = () => {
          const callback = (result) => {
            if (result === 'yes') {
              endOfShift.reset();
              navigateTo('pos.route#more');
              $scope.$apply();
            }
          };
          const message = $translate.instant('AreYouSure');
          displayMessage.message({
            message: message,
            type: 'prompt',
            callback: callback,
          });
        };
      },
    }),
  );
